import React from "react"
import { Helmet } from "react-helmet"
import { useTheme } from "styled-components"

const Metadata = () => {
  const theme = useTheme()
  return (
    <Helmet>
      <html lang="en" />
      <meta name="theme-color" content={theme.colors.background.primary[500]} />
      <meta name="color-scheme" content={theme.mode} />
    </Helmet>
  )
}
export default Metadata
